/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Set_PreferredInputs */

const cs_pipelines_set_preferred = /** @type {(inputs: Pipelines_Set_PreferredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít jako moji výchozí`)
};

const en_pipelines_set_preferred = /** @type {(inputs: Pipelines_Set_PreferredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as my default`)
};

/**
* | output |
* | --- |
* | "Use as my default" |
*
* @param {Pipelines_Set_PreferredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_set_preferred = /** @type {((inputs?: Pipelines_Set_PreferredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Set_PreferredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_set_preferred(inputs)
	return cs_pipelines_set_preferred(inputs)
});